/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiOnboardingStep;
(function (ApiOnboardingStep) {
    ApiOnboardingStep["BASIC_INFO"] = "basic_info";
    ApiOnboardingStep["BUSINESS_INFO"] = "business_info";
    ApiOnboardingStep["PLATFORM"] = "platform";
    ApiOnboardingStep["PIXEL"] = "pixel";
    ApiOnboardingStep["LOCATIONS"] = "locations";
    ApiOnboardingStep["CONNECTIONS"] = "connections";
})(ApiOnboardingStep || (ApiOnboardingStep = {}));
export function ApiOnboardingStepFromJSON(json) {
    return ApiOnboardingStepFromJSONTyped(json, false);
}
export function ApiOnboardingStepFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiOnboardingStepToJSON(value) {
    return value;
}
